import { NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BotCardType, HistoryItemResponse, HtmlCard, IframeCard, ImageCard, LoadingCard, VimeoCard, YoutubeCard } from '@shared/index';
import { SafePipe } from 'src/app/shared/pipes/safe.pipe';
import { BUTTONCARDBUTTON, ButtonCardComponent } from "./button-card/button-card.component";

@Component({
  selector: 'app-message-card',
  templateUrl: './message-card.component.html',
  styleUrl: './message-card.component.scss',
  imports: [NgTemplateOutlet, FormsModule, SafePipe, ButtonCardComponent]
})
export class MessageCardComponent implements OnInit {
  public readonly message = input.required<HistoryItemResponse>();
  public readonly enableDeletion = input<boolean>(false);
  public readonly deleteMessage = output<HistoryItemResponse>();
  public readonly isLast = input.required<boolean>();
  public deleting: boolean = false;
  public type!: BotCardType;
  public buttonCard!: { type: BotCardType, data: { buttons: BUTTONCARDBUTTON[], cssClass: string } };

  public ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    if (msg.type === 'text') {
      this.type = (JSON.parse(msg.text) as { type: BotCardType, data: unknown }).type;
      this.buttonCard = JSON.parse(msg.text) as { type: BotCardType, data: { buttons: BUTTONCARDBUTTON[], cssClass: string } };
    }
  }

  public getCard(): { type: BotCardType, data: unknown } {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as { type: BotCardType, data: unknown };
  }

  public getYoutubeCard(): YoutubeCard {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as YoutubeCard;
  }

  public getHtmlCard(): HtmlCard {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as HtmlCard;
  }

  public getIframeCard(): IframeCard {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as IframeCard;
  }

  public getVimeoCard(): VimeoCard {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as VimeoCard;
  }

  public getImageCard(): ImageCard {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as ImageCard;
  }

  public getLoadingCard(): LoadingCard {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = this.message().content.at(0)!;
    let m: string = '';
    if (msg.type === 'text') {
      m = msg.text;
    }
    return JSON.parse(m) as LoadingCard;
  }

  public deleteMessageAndLoad() {
    this.deleting = true;
    this.deleteMessage.emit(this.message());
  }
}
